import React, {Component} from 'react';

import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import dayjs from "dayjs";
import meetingsApi from '../../../lib/meetings/meetings-api';
import MediaQuery from 'react-responsive'
import { datetimeLocalToString, localToString, stringToDatetimeLocal } from '../../../lib/helpers/datetime-helpers';
import InputsDate from '../inputs-date';

import moment from 'moment';
import seamApi from '../../../lib/seam-api';

window.dayjs = dayjs;

class Calender extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.value !== undefined ? new Date(this.props.value) : new Date(),
            appointments : {},
        };

        this.calEl = null;
    }


    componentDidMount() {
        this.getBookings();

        if (this.props.loading) return;

        if (this.props.value !== undefined) {
            this.onClickDay(this.state.date);
        }
    }


    getBookings(date = this.state.date) {
        let d = dayjs(date);

        if (this.props.seamApi) {
         ;
            seamApi.meetings().getCalendarAvailability(this.props.roomId, {
                from: datetimeLocalToString(d.startOf('M')),
                to: datetimeLocalToString(d.endOf('M'))
            }).then(({ data }) => {
                this.setState({ appointments: data });
                this.setRef({ appointments: data });
            });
        } else {
            meetingsApi.getCalendarAvailability(this.props.roomId, {
                from: datetimeLocalToString(d.startOf('M')),
                to: datetimeLocalToString(d.endOf('M'))
            }).then(({ data }) => {
                this.setState({ appointments: data });
                this.setRef({ appointments: data });
            });
        }
    }

    setRef(r) {
        this.calEl = r;
    }

    handleChange(date) {
        this.setState({date}, () => {
            this.getBookings();
        });
    }

    isDayDisabled(date, view) {
        if (dayjs(date).isBefore(dayjs(), 'day')) return true;

        const d = dayjs(date).format('YYYY-MM-DD HH:mm:ss');

        return this.state.appointments.hasOwnProperty(d) ? !this.state.appointments[d].available : false;
    }

    handleViewChange(data) {
        this.getBookings(data.activeStartDate);
    }

    onClickDay(date) {
        const utc = dayjs(date);
        const d = utc.startOf('day').format('YYYY-MM-DDTHH:mm');

        let params = {}

        if (this.props.meetingRoomBookingId !== undefined && this.props.meetingRoomBookingId !== null) {
            params.ignore_meeting_room_booking_ids = [ this.props.meetingRoomBookingId ]
        }

        if (this.props.seamApi) {
            seamApi.meetings().getCalendarDayAvailability(this.props.roomId, {
                day: d,
                ...params
             }).then(({ data }) => {
                 this.props.onDaySelection({
                     date: dayjs(date).format('YYYY-MM-DD'),
                     ...data,
                 });
             });
        } else {
            meetingsApi.getCalendarDayAvailability(this.props.roomId, {
                day: d,
                ...params
             }).then(({ data }) => {
                 this.props.onDaySelection({
                     date: dayjs(date).format('YYYY-MM-DD'),
                     ...data,
                 });
             });
        }
    }

    onDateChange(value) {
        this.onClickDay(value);
    }

    tileClassName({ activeStartDate, date, view, value }) {
        const currentCalendarDate = dayjs(value).startOf('month');

        // Get the month and year of the day being rendered.
        const dayMonth = dayjs(date).startOf('day');

        // If the day belongs to the previous or next month, hide it.
        if (!dayMonth.isSame(currentCalendarDate, 'month')) {
            return 'appointment-cal--hidden';
        }

        return '';
    }

    render() {
        return (
            <div>
                <MediaQuery minWidth={460}>
                    <Calendar
                        className={'appointment-cal'}
                        inputRef={this.setRef.bind(this)}
                        onChange={this.handleChange.bind(this)}
                        onActiveStartDateChange={this.handleViewChange.bind(this)}
                        onClickDay={this.onClickDay.bind(this)}
                        tileDisabled={({ date, view }) => this.isDayDisabled(date, view)}
                        tileClassName={this.tileClassName.bind(this)}
                        formatDay={(local, date) => {
                                return(
                                    <div className={'appointment-cal__day'}>
                                        { dayjs(date).date() }
                                    </div>
                                );
                        }}
                        value={this.state.date ?? new Date()}
                    />
                </MediaQuery>
                <MediaQuery maxWidth={460}>
                    <InputsDate
                        onChange={this.onDateChange.bind(this)}
                        value={dayjs(this.state.date)}
                    />
                </MediaQuery>
            </div>
        );

    }
}

Calender.defaultProps = {
    relation : null,
    onChange : date => console.log(date)
};

export default Calender;
